import ChatPanel from '@/components/ChatPanel';
import { MessageSquare } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function MessagesPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const focusThreadId = params.get('focus');
  return (
    <div className="space-y-4" data-testid="messages-page">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-sm bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/20">
          <MessageSquare className="w-5 h-5 text-zinc-950" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-zinc-100" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Messages</h1>
          <p className="text-xs text-zinc-500">Discussions en direct avec sous-traitants, commerciaux et clients</p>
        </div>
      </div>
      <ChatPanel mode="page" initialThreadId={focusThreadId} />
    </div>
  );
}
